<template>
  <div class="absolute">
    <ul
      class="text-sm bg-n-solid-1 border border-n-weak rounded-xl shadow-sm py-2 n-dropdown-body gap-2 grid list-none px-2 reset-base"
    >
      <slot />
    </ul>
  </div>
</template>
